<div class="row d-flex justify-content-end container-style px-2 py-1">
  <div class="col-auto pt-1 pb-1">
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      [severity]="'success'" [variant]="undefined" (onClick)="openModalConceptInvoicing()"></app-custom-button>
    <app-custom-modal #conceptInvoicingModal
      [label]="conceptInvoicingType === 1 ? 'Captura Concepto de Facturación' : 'Captura Concepto de Compra'"
      [header]="conceptInvoicingType === 1 ? 'Captura Concepto de Facturación' : 'Captura Concepto de Compra'"
      [children]="componentRegisterConceptInvoicing" [inputs$]="inputsForConceptInvoicing$"
      [output$]="inputsForConceptInvoicing$" [width]="'50rem'" hidden></app-custom-modal>
  </div>
</div>
<div class="container-style mt-2" *ngIf="!isOpened">
  <app-custom-table [showExport]="true" [showImport]="true" [showRecover]="true" [headers]="header" [data]="data"
    [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="url"
    (onRecoverData)="getAllConceptInvoicingsWithPagination()" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)" (onExport)="onExport()" (onImport)="onImport()"
    (onAction)="onAction($event)">
  </app-custom-table>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>

<!-- Modal para importar conceptos -->
<app-custom-modal #conceptInvoicingImportModal [label]="'Importar'" [width]="'40rem'"
  [header]="conceptInvoicingType === 1 ? 'Importar Conceptos de Facturación' : 'Importar Conceptos de Compra'"
  [children]="componentConceptInvoicingImportModal" [inputs$]="inputsForImportConceptInvoicing$"
  (params)="getAllConceptInvoicingsWithPagination()" hidden>
</app-custom-modal>